import { createIcon } from "@chakra-ui/react";

const VisibilityPublicIcon = createIcon({
  displayName: "VisibilityPublicIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 5C16 5 20.5 7.5 22 12C20.5 16.5 16 19 12 19C8 19 3.5 16.5 2 12C3.5 7.5 8 5 12 5ZM12 17.25C8.79498 17.25 5.26618 15.3282 3.86829 12C5.26618 8.67176 8.79498 6.75 12 6.75C15.205 6.75 18.7338 8.67175 20.1317 12C18.7338 15.3282 15.205 17.25 12 17.25Z"
        fill="currentColor"
      />
    </>
  ),
});

export default VisibilityPublicIcon;
